(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carousel-imagens"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const track = document.querySelector('.central-carousel .carousel-track');
  const items = Array.from(track.children);
  const prevBtn = document.querySelector('.central-carousel .carousel-btn.prev');
  const nextBtn = document.querySelector('.central-carousel .carousel-btn.next');

  if(items.length > 2){
    const firstClones = items.map(item => item.cloneNode(true));
    const lastClones = items.map(item => item.cloneNode(true));
    firstClones.forEach(clone => track.appendChild(clone));
    lastClones.reverse().forEach(clone => track.insertBefore(clone, track.firstChild));
  }

  let allItems = Array.from(track.children);
  let currentIndex = items.length;

  function updateCarousel(animate = true) {
    const itemWidth = allItems[0].offsetWidth + parseInt(getComputedStyle(allItems[0]).marginLeft) + parseInt(getComputedStyle(allItems[0]).marginRight);
    const offset = -currentIndex * itemWidth + (track.offsetWidth - itemWidth)/2;
    track.style.transition = animate ? 'transform 0.5s ease' : 'none';
    track.style.transform = `translateX(${offset}px)`;

    const isDesktop = window.innerWidth > 768;

    allItems.forEach((item, index) => {
      const distance = index - currentIndex;
      const absDist = Math.abs(distance);

      let scale = 1, rotateY = 0, translateY = 0, opacity = 1, zIndex = 3;

      if(isDesktop){
        if(absDist === 0) { scale = 1.1; rotateY = 0; translateY = -12; opacity = 1; zIndex = 3; item.classList.add('active'); }
        else if(absDist === 1) { scale = 0.92; rotateY = distance > 0 ? -20 : 20; translateY = 10; opacity = 0.75; zIndex = 2; item.classList.remove('active'); }
        else if(absDist === 2) { scale = 0.82; rotateY = distance > 0 ? -35 : 35; translateY = 18; opacity = 0.55; zIndex = 1; item.classList.remove('active'); }
        else { scale = 0.7; rotateY = distance > 0 ? -50 : 50; translateY = 28; opacity = 0.35; zIndex = 0; item.classList.remove('active'); }
      } else {
        if(absDist === 0) { scale = 1.1; rotateY = 0; translateY = -15; opacity = 1; zIndex = 3; item.classList.add('active'); }
        else if(absDist === 1) { scale = 0.85; rotateY = distance > 0 ? -30 : 30; translateY = 15; opacity = 0.6; zIndex = 2; item.classList.remove('active'); }
        else if(absDist === 2) { scale = 0.7; rotateY = distance > 0 ? -50 : 50; translateY = 25; opacity = 0.4; zIndex = 1; item.classList.remove('active'); }
        else { scale = 0.55; rotateY = distance > 0 ? -70 : 70; translateY = 40; opacity = 0.2; zIndex = 0; item.classList.remove('active'); }
      }

      item.style.transform = `translate3d(0, ${translateY}px, 0) scale(${scale}) rotateY(${rotateY}deg)`;
      item.style.opacity = opacity;
      item.style.zIndex = zIndex;
    });
  }

  function moveNext() {
    currentIndex++;
    updateCarousel();
    if(currentIndex >= allItems.length - items.length) {
      currentIndex = items.length;
      updateCarousel(false);
    }
  }

  function movePrev() {
    currentIndex--;
    updateCarousel();
    if(currentIndex < items.length) {
      currentIndex = allItems.length - (2 * items.length);
      updateCarousel(false);
    }
  }

  if(window.innerWidth > 768){
    nextBtn.addEventListener('click', moveNext);
    prevBtn.addEventListener('click', movePrev);
    setInterval(moveNext, 6000);
  }

  if(window.innerWidth <= 768){
    let startX = 0;
    let endX = 0;

    track.addEventListener('touchstart', e => { startX = e.touches[0].clientX; });
    track.addEventListener('touchend', e => {
      endX = e.changedTouches[0].clientX;
      const dx = endX - startX;

      if(dx > 50){ movePrev(); } 
      else if(dx < -50){ moveNext(); } 
      else { updateCarousel(); }
    });
  }

  updateCarousel();
  window.addEventListener('resize', () => updateCarousel(false));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["colecoes-destaque"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function(){
  const abas = document.querySelectorAll('.aba-colecao');
  const colecoes = document.querySelectorAll('.produtos-colecao');
  const verMaisBtn = document.getElementById('ver-mais-btn');

  // Pré-carrega todas as coleções desktop e mobile para eliminar lag
  colecoes.forEach(c => { c.style.display = 'flex'; c.style.opacity = 1; c.style.transform = 'translateY(0)'; });

  function hideAll(callback){
    colecoes.forEach(c => { c.style.opacity=0; c.style.transform='translateY(20px)'; });
    abas.forEach(a => { a.classList.remove('active'); const linha = a.querySelector('.linha-ativa'); if(linha) linha.style.width='0'; });
    setTimeout(()=>{ 
      colecoes.forEach(c=>c.style.display='none'); 
      if(callback) callback(); 
    }, 490);
  }

  function activateById(id){
    abas.forEach(a => a.classList.remove('active'));
    const abasDoId = document.querySelectorAll('.aba-colecao[data-colecao="'+id+'"]');
    abasDoId.forEach(a=>{
      a.classList.add('active'); 
      const linha = a.querySelector('.linha-ativa');
      if(linha) linha.style.width='100%'; 
      const url = a.getAttribute('data-url');
      if(url && verMaisBtn){ verMaisBtn.setAttribute('href', url); }
    });

    const produtos = document.getElementById('produtos-'+id);
    if(produtos){ produtos.style.display='flex'; setTimeout(()=>{ produtos.style.opacity=1; produtos.style.transform='translateY(0)'; }, 50); }

    const produtosMobile = document.getElementById('mobile-produtos-'+id);
    if(produtosMobile){ produtosMobile.style.display='flex'; setTimeout(()=>{ produtosMobile.style.opacity=1; produtosMobile.style.transform='translateY(0)'; }, 50); }
  }

  abas.forEach(aba => { aba.addEventListener('click', ()=>{ const id=aba.getAttribute('data-colecao'); hideAll(()=>activateById(id)); }); });

  if(abas.length>0){
    const firstId = abas[0].getAttribute('data-colecao');
    hideAll(()=>activateById(firstId));
  }

  // carrossel desktop
  document.querySelectorAll('.carrossel-desktop-wrapper').forEach(wrapper=>{
    const carrossel = wrapper.querySelector('.carrossel-desktop');
    const prev = wrapper.querySelector('.carrossel-prev');
    const next = wrapper.querySelector('.carrossel-next');
    const totalSlides = carrossel ? carrossel.children.length : 0;
    let index=0;

    function update(){
      const produtoWidth = carrossel.children[0].offsetWidth + 2; // gap
      const maxIndex = totalSlides - 4; // 4 produtos visíveis
      if(index > maxIndex) index = maxIndex;
      if(index < 0) index = 0;
      carrossel.style.transform = 'translateX(' + (-produtoWidth * index) + 'px)';
    }

    if(prev) prev.addEventListener('click', ()=>{ index--; update(); });
    if(next) next.addEventListener('click', ()=>{ index++; update(); });
    update();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.querySelectorAll('.collection-tab');
  const productWrapper = document.querySelector('.collection-wrapper');

  // Remove a aba ativa se vier da homepage
  if (document.referrer && new URL(document.referrer).pathname === '/') {
    tabs.forEach(t => t.classList.remove('active'));
  } else {
    const current_handle = window.location.pathname.split('/').pop();
    tabs.forEach(t => {
      if (t.href.includes(current_handle)) t.classList.add('active');
      else t.classList.remove('active');
    });
  }

  // Scroll se houver hash na URL
  const url = new URL(window.location.href);
  if (url.hash) {
    const card = document.getElementById(url.hash.slice(1));
    if (card) card.scrollIntoView({ behavior: 'auto' });
  }

  // AJAX das abas + scroll automático
  tabs.forEach(tab => {
    tab.addEventListener('click', function(e) {
      e.preventDefault();
      tabs.forEach(t => t.classList.remove('active'));
      this.classList.add('active');

      // Scroll da barra para mostrar a aba inteira
      this.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest'
      });

      const url = this.href;
      fetch(url + '?view=ajax-products')
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newProducts = doc.querySelector('.collection-wrapper');
          if (newProducts) {
            productWrapper.innerHTML = newProducts.innerHTML;
            window.history.replaceState(null, '', url);
          }
        })
        .catch(err => console.error('Erro ao carregar produtos da aba:', err));
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-description-tabs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function(){
  const abas = document.querySelectorAll('.aba-descricao');
  const conteudos = document.querySelectorAll('.conteudo-aba');

  function activateById(id){
    abas.forEach(a => a.classList.toggle('active', a.dataset.aba === id));
    conteudos.forEach(c => c.classList.toggle('active', c.id === 'conteudo-' + id));
  }

  abas.forEach(aba => aba.addEventListener('click', () => activateById(aba.dataset.aba)));

  if(abas.length){
    activateById(abas[0].dataset.aba);
  }
});

  } catch(e) { console.error(e); }
})();
})();
